// Test IDs for ExhaleType — central registry used by automated test agent.
export const EXHALE = {
  // landing
  landingRoot: 'exhale-landing',
  beginExhaleBtn: 'begin-exhale-btn',
  brainUnloadBtn: 'brain-unload-btn',
  midnightThoughtsBtn: 'midnight-thoughts-btn',
  beginUnloadBtn: 'begin-exhale-btn', // legacy alias
  exploreModesBtn: 'explore-modes-btn',
  openHistoryBtn: 'open-history-btn',
  settingsBtn: 'open-settings-btn',
  soundToggle: 'sound-toggle',

  // emotional recognition
  recognitionRoot: 'recognition-root',
  recognitionCard: (mode) => `recognition-card-${mode}`,

  // empty history
  emptyBeginExhale: 'empty-begin-exhale-btn',
  emptyBrainUnload: 'empty-brain-unload-btn',

  // header
  brandLink: 'brand-home-link',
  navModes: 'nav-modes',
  navHistory: 'nav-history',

  // modes
  modesRoot: 'modes-root',
  modeCard: (id) => `mode-card-${id}`,

  // session
  sessionRoot: 'session-root',
  canvas: 'exhale-canvas',
  wordCount: 'word-count',
  finishBtn: 'finish-session-btn',
  reflectToggle: 'reflect-toggle',
  reflectionText: 'reflection-text',
  saveBtn: 'save-session-btn',
  newSessionBtn: 'new-session-btn',
  goHomeBtn: 'go-home-btn',

  // history
  historyRoot: 'history-root',
  tabTimeline: 'tab-timeline',
  tabCalendar: 'tab-calendar',
  timelineItem: (id) => `timeline-item-${id}`,
  deleteSession: (id) => `delete-session-${id}`,
  calendarDay: (iso) => `calendar-day-${iso}`,

  // settings
  settingsDialog: 'settings-dialog',
  toggleBreathing: 'toggle-breathing',
  toggleSound: 'toggle-ambient-sound',
  toggleReflections: 'toggle-reflections',
};

export default EXHALE;
